import * as React from "react";
import type { SVGProps } from "react";
const SvgNewbuiltIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 1.12c-4.014 0-7.28 3.266-7.28 7.28 0 2.006.774 4.452 2.047 6.458 1.075 1.69 2.534 3.097 4.253 3.5L12.6 19.6h.665l-.07.21c-.133.383-.315.807-.315 1.365 0 .713.332 1.32.612 1.873S14 24.104 14 24.36c0 1.105-.437 1.61-.437 1.61a.56.56 0 1 0 .874.7s.683-.877.683-2.31c0-.695-.335-1.269-.612-1.82-.278-.551-.508-1.063-.508-1.365 0-.32.1-.584.245-.997.059-.169.12-.361.175-.578h.98l-.42-1.242c1.72-.403 3.178-1.81 4.253-3.5 1.273-2.006 2.047-4.452 2.047-6.458 0-4.014-3.266-7.28-7.28-7.28m0 1.12a6.15 6.15 0 0 1 6.16 6.16c0 1.704-.713 4.019-1.872 5.845-1.16 1.827-2.724 3.115-4.288 3.115s-3.128-1.288-4.288-3.115C8.553 12.42 7.84 10.105 7.84 8.4A6.15 6.15 0 0 1 14 2.24"
    />
  </svg>
);
export default SvgNewbuiltIcon;
